import React, { useCallback } from 'react'
import s from './GeoentityBlockLinkList.less'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import RectangleActionButton, { COLOR_ORANGE_EMPTY } from '../../genericComponents/buttons/RectangleActionButton'

const GeoentityBlockLinkList = props => {
  const list = props?.data?.list

  if (!list) return null

  return (
    <div className={s.linkContainer}>
      {list.slice(0, 3).map(({ aspect, label, tag, templatizedUrl }) => (
        <GeoentitiyBlockLinkListItem
          key={label}
          aspect={aspect}
          label={label}
          tag={tag}
          templatizedUrl={templatizedUrl}
        />
      ))}
    </div>
  )
}

const GeoentitiyBlockLinkListItem = ({ aspect, label, tag, templatizedUrl }) => {
  const sendBiTagNow = useTagBiForGeoentity(tag, { targeturl: templatizedUrl })

  const onClick = useCallback(() => {
    sendBiTagNow()
  }, [sendBiTagNow])

  return (
    <RectangleActionButton
      key={label}
      color={COLOR_ORANGE_EMPTY}
      href={templatizedUrl}
      targetBlank={true}
      nofollow={true}
      onClick={onClick}
      label={label}
    />
  )
}

export default GeoentityBlockLinkList
